import removeNode from '../../helpers/removeNode';
import { removeFromFavourites } from '../../helpers/favouritesHandler';
import initMiniFavourites from '../global/header/miniFavourites';

function updateFavouritesLimitAchieved(totalEntries: number): void {
  const favouritesPageLimitAchievedAlertElement =
    document.querySelector<HTMLParagraphElement>('.wishlist--limit-achieved');
  if (totalEntries < window.globalWishlist.maxTotalLimit) {
    removeNode(favouritesPageLimitAchievedAlertElement);
  }
}

function updateFavouritesViewMoreButton(totalEntries: number): void {
  const favouritesPageLoadMoreButtonElement = document.querySelector<HTMLButtonElement>('.wishlist-view-more');
  favouritesPageLoadMoreButtonElement?.classList[
    totalEntries <= window.globalWishlist.maxDisplayLimit ? 'add' : 'remove'
  ]('hide');
  const favouritesLoadMoreCounter = favouritesPageLoadMoreButtonElement?.querySelector('span');
  if (favouritesLoadMoreCounter) {
    favouritesLoadMoreCounter.textContent = `(${totalEntries})`;
  }
}

export function favouritesPageRemoveButtonHandler(): void {
  const favouritesPageProductsContainer = document.querySelector<HTMLDivElement>('.product-list');
  const favouritesPageEmptyCMSComponentElement = document.querySelector<HTMLDivElement>(
    '.empty-wishlist-cms-component'
  );
  const favouritesPageShareByEmailElement = document.querySelector<HTMLDivElement>('.wishlist-send-list');
  const { updateMiniFavouritesGlobalState, updateMiniFavouritesMarkup } = initMiniFavourites();
  document.addEventListener('click', (e: Event) => {
    const removeButtonElement = (e.target as Element).closest('[data-button-type="favourites-remove"]');
    const productCode = removeButtonElement ? (removeButtonElement as HTMLButtonElement).dataset.productCode : null;
    if (
      productCode &&
      removeButtonElement &&
      window.bbGlobal.miniFavouritesData.isInitialDataFetched &&
      window.bbGlobal.miniFavouritesData.isDataFetching === false
    ) {
      favouritesPageProductsContainer?.style.setProperty('opacity', '0.5');
      favouritesPageProductsContainer?.style.setProperty('pointer-events', 'none');
      window.bbGlobal.miniFavouritesData.isDataFetching = true;
      removeFromFavourites(productCode).then((miniFavouritesData) => {
        const { entries } = miniFavouritesData;
        const totalEntries = entries.length;
        updateMiniFavouritesGlobalState(miniFavouritesData);
        updateMiniFavouritesMarkup(miniFavouritesData);
        removeNode(removeButtonElement.closest('.product-list__item'));
        updateFavouritesLimitAchieved(totalEntries);
        updateFavouritesViewMoreButton(totalEntries);
        favouritesPageEmptyCMSComponentElement?.classList[totalEntries === 0 ? 'remove' : 'add']('hide');
        favouritesPageShareByEmailElement?.classList[totalEntries === 0 ? 'add' : 'remove']('hide');
        favouritesPageProductsContainer?.style.removeProperty('opacity');
        favouritesPageProductsContainer?.style.removeProperty('pointer-events');
        window.bbGlobal.miniFavouritesData.isDataFetching = false;
      });
    }
  });
}

export function favouritesPageViewMoreButtonHandler(): void {
  const favouritesPageProductsContainer = document.querySelector<HTMLDivElement>('.product-list');
  const favouritesPageLoadMoreButtonElement = document.querySelector<HTMLButtonElement>('.wishlist-view-more');
  const onClick = (): void => {
    favouritesPageLoadMoreButtonElement?.removeEventListener('click', onClick);
    favouritesPageProductsContainer?.classList.remove('product-list--hide-results');
    removeNode(favouritesPageLoadMoreButtonElement);
  };

  favouritesPageLoadMoreButtonElement?.addEventListener('click', onClick);
}
